module.exports = __webpack_public_path__ + "media/icons/trash-b2c88239.svg";